<template>
  <f7-page>
    <f7-navbar no-hairline>
      <f7-nav-left>
        <f7-link class="logo" href="/">
          <img
            src="/static/logo.png"
            width="150"
            class="hide-on-tablet"
            alt="Logo"
          />
          <img src="/static/logoIcon.png" class="show-on-tablet" alt="Logo" />
        </f7-link>

        <f7-menu>
          <f7-menu-item
            :text="$root.$i18n.locale"
            icon-f7="chevron_down"
            icon-size="12"
            dropdown
          >
            <f7-menu-dropdown center>
              <f7-menu-dropdown-item
                :external="true"
                href="/"
                text="EN"
              ></f7-menu-dropdown-item>
              <f7-menu-dropdown-item
                :external="true"
                href="/ru"
                text="RU"
              ></f7-menu-dropdown-item>
              <f7-menu-dropdown-item
                :external="true"
                href="/es"
                text="ES"
              ></f7-menu-dropdown-item>
              <f7-menu-dropdown-item
                :external="true"
                href="/pt"
                text="PT"
              ></f7-menu-dropdown-item>
            </f7-menu-dropdown>
          </f7-menu-item>
        </f7-menu>
      </f7-nav-left>

      <!-- <f7-nav-title class="hide-on-mobile">
        {{ $t(`page_home.title`) }}
      </f7-nav-title> -->

      <f7-nav-right>
        <f7-button
          fill
          large
          class="gradient"
          @click="$f7.loginScreen.open('#loginScreen')"
        >
          {{ $t(`log_in`) }}
        </f7-button>
      </f7-nav-right>
    </f7-navbar>

    <div class="page-content-inner">
      <f7-block-title class="nunito-font text-align-center flex-shrink-0" large>
        <h1>
          {{ $t(`page_home.h1.normal`) }}
          <span class="text-color-pink">
            {{ $t(`page_home.h1.mark`) }}
          </span>
        </h1>
      </f7-block-title>

      <f7-block class="margin-top text-align-center">
        {{ $t(`page_home.subtitle`) }}
      </f7-block>

      <!-- <f7-block
        class="api-tab display-flex justify-content-center flex-shrink-0"
      >
        <f7-button
          :class="[
            'button-change-api-type',
            'margin-right',
            { active: apiType === 'PROOFREAD' },
          ]"
          fill
          large
          round
          @click="changeApiType('PROOFREAD')"
        >
          Proofread
        </f7-button>

        <f7-button
          :class="[
            'button-change-api-type',
            'margin-right',
            { active: apiType === 'TRANSLATE' },
          ]"
          fill
          large
          round
          @click="changeApiType('TRANSLATE')"
        >
          Translate
        </f7-button>

        <f7-button
          :class="[
            'button-change-api-type',
            { active: apiType === 'CREATE_CONTENT' },
          ]"
          fill
          large
          round
          @click="changeApiType('CREATE_CONTENT')"
        >
          Create Content
        </f7-button>
      </f7-block> -->

      <div v-if="apiType === 'TRANSLATE' || apiType === 'PROOFREAD'">
        <f7-list class="main-textarea" no-hairlines>
          <f7-list-input
            type="textarea"
            :placeholder="proofreadAndTranslatePlaceholder"
            :value="text"
            @input="$store.commit('SET_TEXT', $event.target.value)"
          >
          </f7-list-input>
        </f7-list>

        <f7-block
          class="show-on-tablet justify-content-center no-padding-horizontal margin-bottom flex-shrink-0"
        >
          <f7-list
            v-if="apiType === 'TRANSLATE' && languagesIn && languagesOut"
            class="list-chose-translate no-margin-vertical"
            no-hairlines
            no-hairlines-between
          >
            <f7-list-item
              title=" "
              smart-select
              :smart-select-params="{ openIn: 'popover' }"
            >
              <select @change="$store.commit('SET_LANGUAGE_ID_IN', lang.id)">
                <option
                  v-for="lang in languagesIn"
                  :key="lang.id"
                  :value="lang.id"
                  :selected="lang.id === languageIdIn"
                >
                  {{ lang.name }}
                </option>
              </select>
            </f7-list-item>

            <f7-icon
              slot="list"
              class="list-chose-translate-arrow"
              f7="arrow_right"
              color="blue"
              size="14"
            ></f7-icon>

            <f7-list-item
              title=" "
              smart-select
              :smart-select-params="{ openIn: 'popover' }"
            >
              <select
                name="superhero"
                @change="$store.commit('SET_LANGUAGE_ID_OUT', lang.id)"
              >
                <option
                  v-for="lang in languagesOut"
                  :key="lang.id"
                  :value="lang.id"
                  :selected="lang.id === languageIdOut"
                >
                  {{ lang.name }}
                </option>
              </select>
            </f7-list-item>
          </f7-list>
        </f7-block>

        <f7-block class="main-total">
          <div class="main-total-info">
            <span class="main-total-info-characters">
              {{ `${characters} ${$t(`characters`)}` }}
            </span>
            <span class="main-total-info-price">{{ `${price}$` }}</span>
          </div>

          <f7-list
            v-if="apiType === 'TRANSLATE' && languagesIn && languagesOut"
            class="list-chose-translate hide-on-tablet"
            no-hairlines
            no-hairlines-between
          >
            <f7-list-item
              title=" "
              smart-select
              :smart-select-params="{ openIn: 'popover' }"
            >
              <select @change="$store.commit('SET_LANGUAGE_ID_IN', lang.id)">
                <option
                  v-for="lang in languagesIn"
                  :key="lang.id"
                  :value="lang.id"
                  :selected="lang.id === languageIdIn"
                >
                  {{ lang.name }}
                </option>
              </select>
            </f7-list-item>

            <f7-icon
              slot="list"
              class="list-chose-translate-arrow"
              f7="arrow_right"
              color="blue"
              size="14"
            ></f7-icon>

            <f7-list-item
              title=" "
              smart-select
              :smart-select-params="{ openIn: 'popover' }"
            >
              <select
                name="superhero"
                @change="$store.commit('SET_LANGUAGE_ID_OUT', lang.id)"
              >
                <option
                  v-for="lang in languagesOut"
                  :key="lang.id"
                  :value="lang.id"
                  :selected="lang.id === languageIdOut"
                >
                  {{ lang.name }}
                </option>
              </select>
            </f7-list-item>
          </f7-list>

          <f7-button
            fill
            large
            round
            @click="$f7.loginScreen.open('#loginScreen')"
          >
            {{ $t(`check_text_now`) }}
          </f7-button>
        </f7-block>
      </div>

      <div v-else class="create-content-block">
        <f7-list class="main-textarea" no-hairlines>
          <f7-list-input
            type="textarea"
            :placeholder="proofreadAndTranslatePlaceholder"
            :value="briefText"
            @input="$store.commit('SET_BRIEF_TEXT', $event.target.value)"
          >
          </f7-list-input>
        </f7-list>
        <!-- <f7-list class="create-content-title-input" no-hairlines>
          <f7-list-input
            type="text"
            :placeholder="$t(`project_title`)"
            :value="briefTitle"
            @input="$store.commit('SET_BRIEF_TITLE', $event.target.value)"
          ></f7-list-input>
        </f7-list>

        <f7-list class="main-textarea" no-hairlines>
          <f7-list-input
            type="textarea"
            :placeholder="$t(`brief_project_instructions`)"
            :value="briefText"
            @input="$store.commit('SET_BRIEF_TEXT', $event.target.value)"
          >
          </f7-list-input>
        </f7-list> -->

        <f7-list
          class="list-chose-translate list-choses no-margin-bottom"
          no-hairlines
          no-hairlines-between
        >
          <!-- <f7-list-item
            title=" "
            smart-select
            :smart-select-params="{ openIn: 'popover' }"
          >
            <div slot="root-start" class="list-chose-translate-title">
              {{ $t('writer_level') }}
            </div>
            <select
              name="level"
              @change="
                (e) => $store.commit('SET_CREATE_CONTENT_LEVEL', e.target.value)
              "
            >
              <option
                v-for="(item, index) in levels"
                :key="index"
                :value="item.title"
                :selected="selectedLevel === item.title"
              >
                {{ item.title }}
              </option>
            </select>
          </f7-list-item> -->

          <!-- <f7-list-item
            title=" "
            smart-select
            :smart-select-params="{ openIn: 'popover' }"
          >
            <div slot="root-start" class="list-chose-translate-title">
              {{ $t(`words_count`) }}
            </div>
            <select
              name="count"
              @change="
                (e) =>
                  $store.commit(
                    'SET_CREATE_CONTENT_WORDS_COUNT',
                    e.target.value
                  )
              "
            >
              <option
                v-for="(item, index) in wordsCount"
                :key="index"
                :value="item.title"
                :selected="selectedWordsCount === item.title"
              >
                {{ item.title }}
              </option>
            </select>
          </f7-list-item> -->

          <f7-list-item
            title=" "
            smart-select
            :smart-select-params="{ openIn: 'popover' }"
          >
            <div slot="root-start" class="list-chose-translate-title">
              {{ $t(`age`) }}
            </div>
            <select
              name="category"
              @change="
                (e) =>
                  $store.commit('SET_CREATE_CONTENT_CATEGORY', e.target.value)
              "
            >
              <option
                v-for="(item, index) in ages"
                :key="index"
                :value="item"
                :selected="selectedCategory === item"
              >
                {{ item }}
              </option>
            </select>
          </f7-list-item>

          <f7-list-item
            title=" "
            smart-select
            :smart-select-params="{ openIn: 'popover' }"
          >
            <div slot="root-start" class="list-chose-translate-title">
              {{ $t(`gender`) }}
            </div>
            <select
              name="type"
              @change="
                (e) => $store.commit('SET_CREATE_CONTENT_TYPE', e.target.value)
              "
            >
              <option
                v-for="(item, index) in genders"
                :key="index"
                :value="item"
                :selected="selectedType === item"
              >
                {{ item }}
              </option>
            </select>
          </f7-list-item>

          <!-- <f7-list-item
            v-if="languagesOut"
            title=" "
            smart-select
            :smart-select-params="{ openIn: 'popover' }"
          >
            <div slot="root-start" class="list-chose-translate-title">
              {{ $t(`language`) }}
            </div>
            <select
              name="language"
              @change="
                (e) => $store.commit('SET_CREATE_CONTENT_LANG', e.target.value)
              "
            >
              <option
                v-for="lang in languagesOut"
                :key="lang.id"
                :value="lang.id"
                :selected="lang.id == selectedLang"
              >
                {{ lang.name }}
              </option>
            </select>
          </f7-list-item> -->
        </f7-list>

        <f7-block class="main-total">
          <div class="main-total-info">
            <span class="main-total-info-characters">
              Response cost:
            </span>
            <span class="main-total-info-price">
              {{ languageIdOut === 2 ? '8.99$' : '15.99$' }}
            </span>
          </div>

          <f7-button
            fill
            large
            class="gradient"
            @click="$f7.loginScreen.open('#loginScreen')"
          >
            {{ $t(`create_conten_now`) }}
          </f7-button>
        </f7-block>
      </div>

      <!-- <f7-block v-if="apiType !== 'CREATE_CONTENT'" class="main-show-examle">
        <f7-button
          :route-props="{ type: 'PROOFREAD', example: true }"
          href="/result/54392"
        >
          {{ $t(`page_home.show_example`) }}
        </f7-button>
      </f7-block> -->

      <page-footer></page-footer>
    </div>
  </f7-page>
</template>

<script>
import { mapState } from 'vuex';
import PageFooter from '../components/Footer.vue';

export default {
  name: 'Home',

  components: {
    PageFooter,
  },

  data() {
    return {
      levels: [{ title: 'Standard' }, { title: 'Premium' }],
      wordsCount: [
        { title: 150 },
        { title: 300 },
        { title: 500 },
        { title: 700 },
        { title: 1000 },
        { title: 1500 },
        { title: 2000 },
        { title: 3000 },
        { title: 4000 },
        { title: 5000 },
        { title: 7000 },
        { title: 10000 },
      ],
      ages: ['18 - 24', '25 - 34', '35 - 44', '45 - 54', '55 - 80'],
      // categories: [
      //   { title: 'All Categories' },
      //   { title: 'Business' },
      //   { title: 'Internet and Businesses Online' },
      //   { title: 'Finance' },
      //   { title: 'Insurance' },
      //   { title: 'Legal' },
      //   { title: 'Real Estate' },
      //   { title: 'Home Based Business' },
      //   { title: 'Writing and Speaking' },
      //   { title: 'Computers and Technology' },
      //   { title: 'Communications' },
      //   { title: 'News and Society' },
      //   { title: 'Relationships' },
      //   { title: 'Reference and Education' },
      //   { title: 'Health and Fitness' },
      //   { title: 'Recreation and Sports' },
      //   { title: 'Travel and Leisure' },
      //   { title: 'Home Improvement' },
      //   { title: 'Home and Family' },
      //   { title: 'Pets' },
      //   { title: 'Automotive' },
      //   { title: 'Cancer' },
      //   { title: 'Food and Drink' },
      //   { title: 'Arts and Entertainment' },
      //   { title: 'Shopping and Product Reviews' },
      //   { title: 'Alternative energy' },
      //   { title: 'Holidays' },
      //   { title: 'Medical' },
      //   { title: 'Science &amp; Technology' },
      //   { title: 'Fashion' },
      //   { title: 'Sports' },
      //   { title: 'Transportation' },
      //   { title: 'Other' },
      //   { title: 'SEO' },
      //   { title: 'Religion' },
      //   { title: 'Politics' },
      //   { title: 'Real Estate' },
      //   { title: 'Website Design' },
      // ],
      types: [{ title: 'Article' }, { title: 'Rewrite' }],
    };
  },

  computed: {
    proofreadAndTranslatePlaceholder() {
      return this.apiType === 'PROOFREAD'
        ? this.$t(`form_fields.proofread_textarea`)
        : this.$t(`form_fields.translate_textarea`);
    },

    characters() {
      return this.text.length;
    },

    price() {
      return (this.text.trim().length * this.pricePerCharacter).toFixed(3);
    },

    priceContent() {
      if (this.selectedLevel === 'Premium') {
        return (
          this.selectedWordsCount *
          7 *
          this.appConfig.price_for_word_content *
          1.8
        ).toFixed(3);
      }

      return (
        this.selectedWordsCount *
        7 *
        this.appConfig.price_for_word_content
      ).toFixed(3);
    },

    genders() {
      return [this.$t(`man`), this.$t(`woman`)];
    },

    ...mapState({
      appConfig: (state) => state.appConfig,
      text: (state) => state.text,
      apiType: (state) => state.apiType,
      languageIdIn: (state) => state.languageIdIn,
      languageIdOut: (state) => state.languageIdOut,
      languagesIn: (state) => state.languages.in,
      languagesOut: (state) => state.languages.out,
      pricePerCharacter: (state) => state.pricePerCharacter,

      briefTitle: (state) => state.createContent.title,
      briefText: (state) => state.createContent.text,
      selectedLevel: (state) => state.createContent.selectedLevel,
      selectedWordsCount: (state) => state.createContent.selectedWordsCount,
      selectedCategory: (state) => state.createContent.selectedCategory,
      selectedType: (state) => state.createContent.selectedType,
      selectedLang: (state) => state.createContent.selectedLang,
    }),
  },

  beforeDestroy() {
    const pageContent = this.$$('.page-content');
    pageContent.off('scroll', this.handleScroll);
  },

  mounted() {
    const pageContent = this.$$('.page-content');
    pageContent.on('scroll', this.handleScroll);
  },

  methods: {
    handleScroll() {
      const pageContent = this.$$('.page-content');
      if (pageContent.scrollTop() > 0) {
        this.$$('.navbar-bg')[0].style.setProperty(
          '--f7-navbar-bg-color',
          '#ffffff'
        );
      } else {
        this.$$('.navbar-bg')[0].style.setProperty(
          '--f7-navbar-bg-color',
          'transparent'
        );
      }
    },

    changeApiType(type) {
      if (type === 'CREATE_CONTENT') {
        this.setup();
      }

      this.$store.commit('CHANGE_API_TYPE', type);
      this.$store.commit(
        'SET_PRICE',
        type === 'PROOFREAD'
          ? this.appConfig.price_for_word_proofread
          : type === 'TRANSLATE'
          ? this.appConfig.price_for_word_translate
          : this.appConfig.price_for_word_content
      );
    },

    setup() {
      this.$store.commit('SET_CREATE_CONTENT_LEVEL', this.levels[0].title);
      this.$store.commit(
        'SET_CREATE_CONTENT_WORDS_COUNT',
        this.wordsCount[0].title
      );
      this.$store.commit(
        'SET_CREATE_CONTENT_CATEGORY',
        this.categories[0].title
      );
      this.$store.commit('SET_CREATE_CONTENT_TYPE', this.types[0].title);
      this.$store.commit('SET_CREATE_CONTENT_LANG', this.languagesOut[0].id);
    },
  },
};
</script>
